import { Attr, IndexedMesh }  from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";


export type UVAttr = { uv: Attr };

export class TransposeUV<T extends UVAttr> extends IndexedMeshWriter<T> {

    /** The mesh to  */
    writer: IndexedMeshWriter<T>;

    /**
     * Swaps the U and V coordinates of the given mesh, in effect rotating
     * and flipping the texture.
     */
    constructor(writer: IndexedMeshWriter<T>) {
        super();
        this.writer = writer;
    }

    computeAttributeCounts(): IndexedMesh<T> {
        return this.writer.computeAttributeCounts();
    }

    computeMeshData(result: IndexedMesh<T>): void {
        this.writer.computeMeshData(result);
        if(result.attrs.uv == null) {
            return;
        }

        const uv = result.attrs.uv.data;

        let i = 0;
        while(i < uv.length) {
            const
                u = uv[i],
                v = uv[i+1];
            uv[i]   = v;
            uv[i+1] = u;
            i += 2;
        }
    }
}
